import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'
import DataKeys from 'k8s/DataKeys'

export const availabilityZonesSelector = createSharedSelector(
  getDataSelector<DataKeys.AvailabilityZones>(DataKeys.AvailabilityZones),
  (availabilityZones) => {
    return availabilityZones.map((availabilityZone) => {
      // any model changes go here
      return availabilityZone
    })
  },
)
